import React, { useEffect } from "react";
import "./Dashboard.css";
import Appointments from "../../components/appointments/Appointments";
import Monitoring from "../../components/monitoring/Monitoring";
import Menu from "../../components/menu/Menu";

const Dashboard = (props) => {
  useEffect(() => {
    props.actSidebar(true);
  }, [props]);

  useEffect(() => {
    window.onbeforeunload = null;
    localStorage.removeItem("prev_link");
    localStorage.removeItem("disableUnLoad");
    localStorage.removeItem("ExerBuilderEdited");
  }, []);

  return (
    <div className="pageContainer">
      <Menu title={"Dashboard"} />
      <div className="dash_info_hold" 
      style={{background: 'transparent', border: 'none'}}
      >
        <div
          className="dash_inner_container"
        >
          <div className="dash_card_one">
            <Appointments checkLoggedIn={props.checkLoggedIn} />
          </div>

          <div className="dash_card_two">
            <Monitoring checkLoggedIn={props.checkLoggedIn} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
